import { Cartesian2dAxisLabelConfig, CartesianPlotConstructionOptions, EScreenUnit, Scene2dCategorySorted, Sorted2dUpdateStrategy, Update2dGroup } from "@visualization-tools/cartesian-2d";
import { Margin2d, RgbaColorPacker } from "rc-js-util";
const gutterOptions = {
    margins: Margin2d.f32.factory.createOne(50, 20, 10, 30),
    unit: EScreenUnit.CssPixel,
};
const axisOptions = new Cartesian2dAxisLabelConfig({
    fontFamilies: ["sans-serif"],
    fontSize: 12,
    maxWidth: 50,
    formatNumber: (value) => value.toPrecision(3),
    textColor: RgbaColorPacker.packColor(240, 240, 240, 255),
    padding: 14,
});
const traceOptions = {
    traceColor: RgbaColorPacker.packColor(0, 201, 201, 255),
    maxTraceCount: 5,
    traceLinePixelSize: 2,
};
export function getTestPlotOptions(options) {
    return new CartesianPlotConstructionOptions({
        plotName: options.plotName,
        plotRange: options.plotRange,
        gutterOptions: gutterOptions,
        plotPosition: options.plotPosition,
        axisConfig: axisOptions,
        traceOptions: traceOptions,
        updateGroup: new Update2dGroup(options.updateArgProvider),
        createUpdateStrategy: (plot, updateGroup) => {
            return new Sorted2dUpdateStrategy(plot, updateGroup, new Scene2dCategorySorted(updateGroup), (updateArg) => updateArg.userTransform);
        },
    });
}
//# sourceMappingURL=get-test-plot-options.js.map